import { useUpdateMedicineSummary } from 'src/hooks/summary';
import { createMedicinePayload } from 'src/utils/summary/helpers';
import PrescriptionFormModal from './PrescriptionFormModal';
import { showToastSuccess } from 'src/utilities/toast';
import { showToastError } from 'src/utilities/errortoast';

const SavePrescriptionReviewModal = ({
  open,
  onClose,
  editingPrescription,
  encounterId,
  onSave,
}) => {
  const updateMedicineMutation = useUpdateMedicineSummary();

  const handleSave = async (values) => {
    const medicineData = createMedicinePayload(values, editingPrescription);

    try {
      await updateMedicineMutation.mutateAsync({
        encounterId,
        medicines: [medicineData],
      });

      onSave(values, medicineData.order_type_id);
      const action = editingPrescription ? 'updated' : 'added';
      showToastSuccess(`Prescription ${values.name} ${action}.`);
      onClose();
    } catch (error) {
      console.error('Error saving prescription:', error);
      showToastError(`Failed to save prescription ${values.name}.`);
    }
  };

  return (
    <PrescriptionFormModal
      open={open}
      onClose={onClose}
      onSubmit={handleSave}
      initialValues={editingPrescription}
      encounterId={encounterId}
    />
  );
};

export default SavePrescriptionReviewModal;
